import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { enum_api_uri } from "../utils/enum";

interface PostNoticeRequest {
    category: string;
    name: string;
    subject: string;
    contents: string;
    notice: number;
    b_file: File[];
}

interface PostNoticeResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

const createFormData = (data: PostNoticeRequest) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        let value = data[key as keyof PostNoticeRequest];

        if (key === "b_file" && Array.isArray(value)) {
            value.forEach(file => {
                formData.append("b_file", file);
            });
        } else if (value === null) {
            formData.append(key, "");
        } else {
            formData.append(key, value.toString());
        }
    });

    return formData;
};

export const usePostConsoleNotice = (): UseMutationResult<PostNoticeResponse, Error, PostNoticeRequest, unknown> => {
    // const queryClient = useQueryClient();
    const accessToken = useConsoleAuthStore(state => state.accessToken);
    const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
    };

    return useMutation<PostNoticeResponse, Error, PostNoticeRequest>({
        mutationFn: async (data: PostNoticeRequest) => {
            const url = enum_api_uri.post_console_notice.replace(":category", data.category);
            const formData = createFormData(data);
            try {
                const response = await axiosInstance.post(url, formData, { headers });
                return response.data;
            } catch (error: any) {
                // 백엔드 안내 메시지(예: 파일 용량 초과)를 그대로 노출
                throw new Error(error?.response?.data?.message || error?.message || "등록에 실패했습니다.");
            }
        },
        onSuccess: data => {
            return data;
        },
    });
};
